import { LoadingOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type Bundle from 'stores/Bundle';

const LoadingIcon = styled(LoadingOutlined)`
  align-self: center;
`;

export interface BundleLoadingSpinnerProps {
  bundle: Bundle;
}

function BundleLoadingSpinner({ bundle }: BundleLoadingSpinnerProps) {
  return bundle.loading ? <LoadingIcon /> : null;
}

export default observer(BundleLoadingSpinner);
